import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormContext } from '../../../hooks/useForm';
import FormWrapper from '../../FormWrapper';
import { Environments } from '../../../helpers/constants';

const VALIDATOR_STATES = [
  { id: 'CLOSED' },
  { id: 'GARAGE' },
  { id: 'ACCESS' },
  { id: 'COMMERCIAL' },
  { id: 'STATISTICS' },
  { id: 'CONTROL' },
];

const AdditionalInfo = ({ isPassTitle, canEdit = true }) => {
  const { t } = useTranslation();

  const form = useContext(FormContext);

  const { value, input, select, checkbox } = form;

  const environment = useMemo(() => window._env_.ENVIROMENT, []);

  return (
    <>
      <FormWrapper>
        <FormWrapper.Single>
          <FormWrapper.Select
            label={t('entity.offers.product.validStates._')}
            props={{
              options: VALIDATOR_STATES,
              mode: 'multiple',
              allowClear: true,
              labelProp: ({ id }) =>
                t(`entity.offers.product.validStates.${id}`),
              ...select('validStates'),
              disabled: value.deleted || !canEdit,
            }}
          />
          <FormWrapper.Number
            label={t('entity.offers.product.maxValue')}
            props={{
              ...input('maxValue'),
              disabled: value.deleted || !canEdit,
            }}
          />
          {environment === Environments.PITESTI && (
            <FormWrapper.Number
              label={t('entity.offers.product.validityStartOffsetDays')}
              props={{
                ...input('validityStartOffsetDays'),
                disabled: value.deleted || !canEdit,
                min: 0,
                max: 90,
              }}
            />
          )}
          {environment === Environments.PITESTI && (
            <FormWrapper.Number
              label={t('entity.offers.product.maxDaysBeforeExpiryForRecharge')}
              props={{
                ...input('maxDaysBeforeExpiryForRecharge'),
                disabled: value.deleted || !canEdit,
                min: 0,
              }}
            />
          )}
          <FormWrapper.Number
            label={t('entity.offers.product.dispDivFct')}
            props={{
              ...input('dispDivFct'),
              min: 0,
              max: 100,
              disabled: value.deleted || !canEdit,
            }}
          />

          <FormWrapper.Number
            label={t('entity.offers.product.dispId')}
            props={{ ...input('dispId'), disabled: value.deleted || !canEdit }}
          />

          <FormWrapper.Number
            label={t('entity.offers.product.dispId2')}
            props={{ ...input('dispId2'), disabled: value.deleted || !canEdit }}
          />

          <FormWrapper.Number
            label={t('entity.offers.product.dispId2valStart')}
            props={{
              ...input('dispId2valStart'),
              disabled: value.deleted || !canEdit,
            }}
          />
          {isPassTitle && (
            <FormWrapper.Switch
              label={t('entity.offers.product.extensionPeriodRecharge')}
              props={{
                ...checkbox('extensionPeriodRecharge'),
                disabled: !canEdit,
              }}
            />
          )}
        </FormWrapper.Single>
      </FormWrapper>
    </>
  );
};

export default AdditionalInfo;
